import { connect } from 'react-redux';
import { get } from 'lodash';
import WhiteListAddressSidePaneComponent from './WhiteListAddressSidePaneComponent';
import { positionByProductIdSelector } from 'apex-web/lib/redux/selectors/positionSelectors';
import { fetchAccountWithdrawInfos } from 'apex-web/lib/redux/actions/eotcWithdrawActions';
import { whiteListedAddressesSelector } from 'apex-web/lib/redux/selectors/depositWithdrawalSelectors';

const mapStateToProps = (state, ownProps) => {
  const ProductId = get(state, 'apexCore.position.selectedProductId', null);
  const productSymbol = get(ownProps, 'product.ProductSymbol', null);
  const position = positionByProductIdSelector(ProductId)(state);
  const decimalPlaces = state.apexCore.product.decimalPlaces[productSymbol];
  const product = { ...ownProps.product, decimalPlaces };

  const { selectedAccountId } = state.user;

  const verificationLevelConfig =
    get(state, ['user', 'verificationLevelConfigs', 'Products'], []).find(
      i => i.ProductId === ProductId
    ) || {};

  return {
    hasExistingAddresses: whiteListedAddressesSelector(state).length > 0,
    position,
    product,
    selectedAccountId,
    verificationLevelConfig,
    hideHeader: true,
    ProductId
  };
};

const mapDispatchToProps = {
  fetchAccountWithdrawInfos
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WhiteListAddressSidePaneComponent);
